// extracted by mini-css-extract-plugin
module.exports = {"Phonetics":"Phonetics_Phonetics__3Pdih"};